module.exports = __webpack_public_path__ + "img/e683672.jpg";